import {
    COMPANY_LOAD_FAIL,
    COMPANY_LOAD_REQUEST,
    COMPANY_LOAD_RESET,
    COMPANY_LOAD_SINGLE_FAIL,
    COMPANY_LOAD_SINGLE_REQUEST,
    COMPANY_LOAD_SINGLE_RESET,
    COMPANY_LOAD_SINGLE_SUCCESS,
    COMPANY_LOAD_SUCCESS,
    COMPANY_CREATE_SUCCESS,
    COMPANY_CREATE_FAIL,
  } from "../constants/companyConstant";
  
  export const loadCompanyReducer = (state = { company: [] }, action) => {
    switch (action.type) {
      case COMPANY_LOAD_REQUEST:
        return { loading: true };
      case COMPANY_LOAD_SUCCESS:
        return {
          loading: false,
          success: action.payload.success,
          // page: action.payload.page,
          // pages: action.payload.pages,
          // count: action.payload.count,
          // setUniqueLocation: action.payload.setUniqueLocation,
          company: action.payload,
        };
      case COMPANY_CREATE_SUCCESS:
        return {
          ...state,
          company: [...state.company, action.payload.company],
          loading: false,
        };
      case COMPANY_LOAD_FAIL:
        return {
          loading: false,
          error: action.payload,
        };
      case COMPANY_CREATE_FAIL:
        return {
          loading: false,
          error: action.payload,
        };
      case COMPANY_LOAD_RESET:
        return {};
      default:
        return state;
    }
  };